import * as HTTP from './http';

export const Login = async (email, password) => {
    let endpoint = `sessions/login`;

    var body = {
        email: email,
        password: btoa(password)
    };

    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: sessions.login\n${e}`);
        return undefined;
    }

    return result;
}

export const Direct = async (data) => {
    let endpoint = `sessions/direct`;

    var body = {
        rfid: btoa(data)
    };

    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: sessions.direct\n${e}`);
        return undefined;
    }

    return result;
}

export const Internal = async (email, password) => {
    let endpoint = `sessions/internal`;

    var body = {
        email: email,
        password: btoa(password)
    };

    try{
        var result = await HTTP.POST(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: sessions.login\n${e}`);
        return undefined;
    }

    return result;
}